<template>
  <div>
    <v-card-text>
      <v-form v-if="canCreateTeam">
        <v-container>
          <v-row>
            <v-col
              cols="12"
            >
              <p>Enter team name</p>
              <v-text-field
                id="new-team-name"
                v-model="teamName"
                class="adjust-label"
              />
            </v-col>
            <v-col
              cols="12"
            >
              <p>Enter team description</p>
              <v-text-field
                id="update-team-description"
                v-model="teamDescription"
                class="adjust-label"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>

    <v-divider />

    <v-card-actions>
      <v-btn
        color="primary"
        text
        class="cancel-button"
        @click="closeDialog()"
      >
        Cancel
      </v-btn>
      <v-spacer />
      <v-btn
        v-if="canCreateTeam"
        color="primary"
        text
        class="submit-button"
        @click="createNewTeam()"
      >
        Submit
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import TeamsClient from '@/api/TeamsClient';
import { mapGetters } from 'vuex';

export default {
  watch: {
    teamDescription(val) {
      if (val && val.length > 500) {
        this.teamDescription = val.slice(0, 500);
      }
    },
  },
  name: 'TeamAdd',
  props: {
    currentUser: {
      type: Object,
      default: () => {},
    },
    teamsCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      haveTeam: this.currentUser.team !== '',
      teamName: '',
      teamDescription: '',
    };
  },
  computed: {
    ...mapGetters({
      currentJwtToken: 'currentJwtToken',
      currentHackathonId: 'currentHackathonId',
    }),
    canCreateTeam() {
      return (this.$store.state.eventState === 'Registration') && this.currentUser.team === ''
        && !this.currentUser.isAdmin;
    },
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog');
    },
    async createNewTeam() {
      const newTeam = {
        name: this.teamName,
        description: this.teamDescription,
      };
      try {
        /* eslint-disable-next-line max-len */
        const teamsClient = new TeamsClient(this.currentJwtToken, this.currentHackathonId);
        await teamsClient.createTeam({ ...newTeam });
        this.closeDialog();
        this.$router.go();
      } catch (err) {
        /* eslint-disable-next-line no-alert */
        alert('Unable to create a team. Please reach out to an event admin for more information.');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.submit-button {
  text-transform: none;
  background-color: #004e7d !important;
  color: #fff !important;
}

.cancel-button {
  text-transform: none;
  color: #004e7d !important;
}

.adjust-label {
  margin-top: 0;
  padding-top: 0;
}
</style>
